import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';
import infositeLogo from '../images/infosite-logo.png';
import { Helmet } from 'react-helmet-async';
import { Button } from 'rsuite';

function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    if (!email || !password || !firstName || !lastName) {
      toast.error('Uppgifter måste fyllas i.', { position: 'bottom-right' });
      return;
    }
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password, firstName, lastName }),
      });

      if (!response.ok) {
        toast.error('Registreringen misslyckades.', { position: 'bottom-right' });
        throw new Error('Registreringen misslyckades, ' + response.status);
      }

      const data = await response.json();
      toast.success('Registreringen lyckades!', { position: 'bottom-right' });
      navigate('/login');

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Helmet>
              <title>{`Skapa konto`}</title>
            </Helmet>
    <div className='background-color'>
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className='card p-4 shadow-lg bg-dark' style={{ width: '400px'}}>
            <div>
                <img src={infositeLogo} alt="Infosite Logo" style={{ width: '300px'}}/>
            </div>
          {error && <div className="alert alert-danger mb-0 mt-2">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className='mb-4'>
              <label className='form-label text-white' htmlFor="email">E-post</label>
              <input
                className='form-control'
                type="text"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label className='form-label text-white' htmlFor="password">Lösenord</label>
              <input
                className='form-control'
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label className='form-label text-white' htmlFor="firstName">Förnamn</label>
              <input
                className='form-control'
                type="text"
                id="firstName"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
              <label className='form-label text-white' htmlFor="lastName">Efternamn</label>
              <input
                className='form-control'
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>
            <Button className='w-100 d-flex justify-content-center align-items-center text-white mb-1' color='cyan' appearance="primary" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <Loader className="me-2" /> Registrerar...
                </>
              ) : (
                'Registrera'
              )}
            </Button>
            <hr className='text-white' />
            <Link to="/" className='text-decoration-none text-white'>
              <p className='mb-0'>Logga in istället</p>
            </Link>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default RegisterPage;
